module.exports = __webpack_public_path__ + "img/es.9605eb65.svg";